import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { useUpdateSelectedOptionsMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'IndustriesOptions',
  props: {
    userInput: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useUpdateSelectedOpt = useUpdateSelectedOptionsMutation(),
      updateSelectedOptions = _useUpdateSelectedOpt.mutate;
    var valueChange = function valueChange(val) {
      var values = val === undefined ? [] : props.isMultiple ? val : [val];
      updateSelectedOptions({
        userInputId: props.userInput.id,
        values: values
      });
    };
    var value = computed(function () {
      var _props$userInput$sele, _props$userInput, _props$userInput$sele2;
      var values = (_props$userInput$sele = (_props$userInput = props.userInput) === null || _props$userInput === void 0 ? void 0 : (_props$userInput$sele2 = _props$userInput.selectedOptions) === null || _props$userInput$sele2 === void 0 ? void 0 : _props$userInput$sele2.map(function (e) {
        return e.id;
      })) !== null && _props$userInput$sele !== void 0 ? _props$userInput$sele : [];
      return props.isMultiple ? values : values[0];
    });
    return {
      __sfc: true,
      props: props,
      updateSelectedOptions: updateSelectedOptions,
      valueChange: valueChange,
      value: value
    };
  }
});